import React from 'react';
import PropTypes from 'prop-types';

import Badge from "components/Badge";

import {black500} from "assets/jss/main";

HeaderProductInfos.propTypes = {
    name: PropTypes.string,
    tag: PropTypes.string,
    sku: PropTypes.string,
    brand: PropTypes.string
};

function HeaderProductInfos({name = null, tag = null, sku = null, brand = null}) {
    return (
        <div style={{display: 'flex', flexDirection: 'column'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                <div style={{fontSize: '24px', color: black500, fontWeight: 600}}>
                    {name}
                </div>
                <Badge rounded>{tag}</Badge>
            </div>
            <div style={{fontSize: '14px', color: '#6b7280'}}>
                {sku} · {brand}
            </div>
        </div>
    );
}

export default HeaderProductInfos;
